import styled from 'styled-components';

export const NavBar = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  padding: 10px;
  justify-content: flex-end;
  column-gap: 10px;
`;

export const LeaderBtn = styled.button`
  text-transform: capitalize;
  background: ${({ admin }) => (admin ? '#FFF5E7' : '#E7F3FF')};
  border-radius: 12px;
  padding: 2px 6px;
  font-size: 10px;
  line-height: 12px;
  font-weight: 600;
  margin-left: 5px;
  color: ${({ admin }) => (admin ? '#995C00' : '#0a84ff')};
`;

export const PrevPage = styled.div`
  display: none;
  z-index: 1000;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 2px 6px rgb(0 0 0 / 10%);
  svg {
    width: 100%;
    height: 100%;
    circle {
      fill: rgba(255, 255, 255, 0.6);
    }
  }
  @media (max-width: 800px) {
    display: block;
  }
`;
export const NextPage = styled(PrevPage)`
  transform: scaleX(-1);
`;

export const Login = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
  min-height: 100vh;
`;
export const LoginContent = styled.div`
  padding-top: 120px;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 480px) {
    width: 100%;
    padding-top: 20vw;
    padding-bottom: 10vw;
  }
`;

export const LogoContainer = styled.div`
  img {
    width: 375px;
    height: 100px;
    object-fit: contain;
    @media (max-width: 480px) {
      width: 65vw;
    }
  }
`;
export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ButtonsContent = styled.div`
  padding-top: 101px;
  align-items: center;
  flex-direction: column;
  display: flex;
  @media (max-width: 480px) {
    width: 100vw;
    padding: 0 5vw;
    margin-top: 15vw;
  }
`;

export const LoginButton = styled.button`
  margin-bottom: 16px;
  height: 56px;
  width: ${(props) => (props.width ? props.width : '286px')};
  justify-content: center;
  ${(props) =>
    props.color === 'white' ? 'border: 2px solid #ecedf0' : 'border: none'};
  box-sizing: border-box;
  border-radius: 100px;

  :disabled {
    background-color: #dedede;
    color: #ffffff;
    cursor: not-allowed;

    &:hover {
      box-shadow: none;
    }
  }

  ${(props) => props.color === 'black' && 'background: #222224'};
  ${(props) => props.color === 'blue' && 'background: #4285F4'};
  ${(props) => props.color === 'white' && 'background: #FFFFFF'};

  font-weight: 600;
  font-size: 16px;
  line-height: 19px;

  display: flex;
  align-items: center;

  ${(props) => (props.color === 'white' ? 'color: #222224' : 'color: #FFFFFF')};

  transition: all 0.1s ease-in-out;
  &:hover {
    box-shadow: 0px 0px 6px 5px rgb(0 0 0 / 20%);
  }
  &:active {
    box-shadow: inset 0px 0px 11px 8px rgb(255 255 255 / 40%);
  }
  @media (max-width: 480px) {
    width: 100%;
    height: 15vw;
    border-radius: 15vw;
    font-size: 4.3vw;
    line-height: 1;
    svg {
      width: 6vw;
      height: auto;
    }
    &:hover {
      box-shadow: 0px 0px 1vw 1vw rgb(0 0 0 / 20%);
    }
    &:active {
      box-shadow: inset 0px 0px 2vw 1vw rgb(255 255 255 / 40%);
    }
  }
`;

export const SignInButton = styled.p`
  cursor: pointer;
  margin-top: ${(props) => (props.resPas ? '24px' : '8px')};

  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  display: flex;
  align-self: center;

  color: #7f7f82;

  b {
    color: #222224;
    font-weight: bold;
  }
  @media (max-width: 480px) {
    margin-top: 5vw;
    font-size: 4.2vw;
    line-height: 110%;
  }
`;
export const ResetPasswordButton = styled.p`
  cursor: pointer;
  margin-top: 8px;

  font-weight: normal;
  font-size: 14px;
  line-height: 18px;

  display: flex;
  align-self: center;

  color: #2f71eb;

  b {
    color: #222224;
    font-weight: bold;
  }
  @media (max-width: 480px) {
    margin-top: 5vw;
    font-size: 4.2vw;
    line-height: 110%;
  }
`;

export const Powered = styled.p`
  font-weight: normal;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 16px;

  color: #4b4b4d;
  @media (max-width: 480px) {
    font-size: 4.2vw;
    line-height: 110%;
    margin-bottom: 8px;
  }
`;

export const TogatherWebsite = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;

  display: flex;
  align-items: flex-end;

  flex-grow: 1;

  color: #7F7F82;
  margin-bottom: 32px;
  cursor: pointer;
`;

export const TextField = styled.input`
  background: #ffffff;
  width: 100%;
  border: 2px solid #ecedf0;
  box-sizing: border-box;
  border-radius: 14px;

  :disabled {
    cursor: not-allowed;
  }

  font-weight: normal;
  font-size: 18px;
  line-height: 30px;

  color: #222224;
  padding: 14px 20px;
  outline: none;

  margin-top: 8px;
  margin-bottom: ${({ mrgb }) => mrgb + 'px'};
  @media (max-width: 1200px) {
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 16px;
    line-height: 1;
  }
  @media (max-width: 1024px) {
    padding: 8px;
    font-size: 14px;
    line-height: 110%;
    margin-top: 4px;
  }
  @media (max-width: 800px) {
    font-size: 16px;
    padding: 14px 12px;
  }
  @media (max-width: 610px) {
    font-size: 4vw;
    padding: 2vw 3vw;
    border-radius: 2vw;
  }
`;

export const Popup = styled.div`
  display: block;
  opacity: ${(props) => (props.open ? '1' : '0')};
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  width: fit-content;
  border: 2px solid #ecedf0;
  background: #ffffff;
  position: absolute;
  right: 0px;
  top: 0px;

  top: ${(props) => props.pos && props.pos.offsetTop + 'px'};
  left: ${(props) => props.pos && props.pos.offsetLeft - 10 + 'px'};
  z-index: 15;

  padding: 4px 10px;

  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.04),
    0px 5px 10px rgba(0, 0, 0, 0.12);
  border-radius: 16px;
  max-height: 530px;
  max-width: 250px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0;
  }
  @media (max-width: 610px) {
    max-height: 75vw;
    padding: 1vw 2vw;
    border-radius: 3vw;
  }
`;

export const PopupTitle = styled.div`
  color: #7f7f82;
  font-weight: normal;
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  text-align: left;
  padding: 5px;
  @media (max-width: 610px) {
    padding: 1vw 0 1vw 2vw;
    font-size: 4vw;
    line-height: 5vw;
  }
`;
export const MainContainer = styled.div`
  flex-grow: 1;
  height: 100vh;
  display: flex;
  width: calc(100%-108px);
  padding-left: 85px;
  @media (max-width: 1200px) {
    flex-grow: 0;
    width: calc(100% - 80px);
    padding-left: 80px;
  }
  @media (max-width: 1024px) {
    padding-left: 66px;
    width: calc(100% - 66px);
  }
  @media (max-width: 610px) {
    padding-left: 0;
    width: 100%;
  }
`;
export const ListContainer = styled.div`
  border-right: 1px solid #fafafa;
  position: relative;
  width: 100%;
  max-width: ${(props) => (props.membersFiltered ? '488px' : '520px')};
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  align-items: center;
  ::-webkit-scrollbar {
    width: 0;
  }
  @media (max-width: 1200px) {
    padding: 60px 15px 10px 15px;
  }
  @media (max-width: 1024px) {
    padding: 60px 10px 10px 10px;
  }
  @media (max-width: 800px) {
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 66px;
    width: calc(100vw - 66px);
    transition: 0.4s;
    transform: translateX(${(props) => (props.active ? 0 : '-100vw')});
    z-index: ${(props) => (props.active ? 10 : 0)};
    padding: 60px 20px 20px 20px;
  }
  @media (max-width: 610px) {
    width: calc(100% - 13vw);
    padding: 12vw 3vw 3vw 3vw;
    left: 13vw;
  }
`;
export const ScrollWrapper = styled.div`
  width: 100%;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 0;
  }
  position: relative;
`;
export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 60px 20px 16px 20px;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1200px) {
    padding: 0 0 0 18px;
    margin-bottom: 13px;
    flex-wrap: wrap;
  }
  @media (max-width: 1024px) {
    margin-bottom: 10px;
    padding-left: 10px;
    align-items: center;
  }
  @media (max-width: 800px) {
    margin-bottom: 16px;
  }
  @media (max-width: 610px) {
    margin-bottom: 3vw;
    padding-left: 3vw;
  }
`;

export const FiltersContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 0 18px 16px;
  align-items: center;
  position: relative;
  column-gap: 12px;
  @media (max-width: 1200px) {
    padding: 0 0 18px 18px;
    row-gap: 10px;
    /* flex-wrap: wrap; */
  }
  @media (max-width: 1024px) {
    padding-left: 10px;
  }
  @media (max-width: 610px) {
    padding-left: 3vw;
    column-gap: 2.7vw;
    row-gap: 2.7vw;
  }
`;
export const TitlePage = styled.h1`
  font-weight: 800;
  font-size: 28px;
  line-height: 34px;
  color: #222224;
  width: fit-content;
  svg {
    margin-right: 12px;
  }
  @media (max-width: 1024px) {
    display: block;
    line-height: 1;
    font-size: 22px;
    height: fit-content;
  }
  @media (max-width: 610px) {
    font-size: 6vw;
  }
`;

export const GroupBtn = styled.div`
  display: flex;
  column-gap: 10px;
  @media (max-width: 610px) {
    column-gap: 3vw;
  }
`;

export const CalendarButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px;
  border-radius: 20px;
  cursor: pointer;
  background: #fafafa;
  color: #222224;
  &:hover {
    background-color: rgba(140, 16, 254, 0.05);
  }
  :disabled{
    cursor: not-allowed;
    color: #bdbdc1;
    svg{
      fill: #bdbdc1;
    }
  }
  
  span {
    font-weight: 600;
    margin-left: 5px;
  }
  svg{
    fill: #222224;
  }
  @media (max-width: 610px) {
    margin: 5px 0;
  }
  @media (max-width: 500px) {
    padding: 10px;
    border-radius: 50%;
    span {
      display: none;
    }
  }
`;

export const Button = styled.button`
  position: relative;
  padding: 8px 12px;
  background: ${(props) => (props.active ? '#222224' : '#FAFAFA')};
  ${(props) => props.grayBackground && 'background: #e3e3e3 '};
  ${({ search }) => search && 'margin-left: auto'}
  display: flex;
  border-radius: 18px;
  height: fit-content;
  color: ${(props) => (props.active ? '#FFFFFF' : '#4B4B4D')};

  font-weight: 600;
  font-size: 14px;
  line-height: 17px;

  :disabled {
    cursor: not-allowed;
  }

  svg {
    path {
      fill: ${(props) => (props.active ? 'white' : 'black')};
    }
  }
  &:hover {
    background: ${(props) => !props.active && 'rgba(140, 16, 254, 0.05)'};
  }
  @media (max-width: 1024px) {
    line-height: 1;
    font-size: 12px;
    height: fit-content;
    padding: 6px 10px;
    border-radius: 14px;
    svg {
      height: 12px;
    }
  }
  @media (max-width: 800px) {
    font-size: 16px;
    padding: 8px 14px;
    svg {
      height: 16px;
    }
  }
  @media (max-width: 610px) {
    font-size: 4vw;
    width: fit-content;
    svg {
      height: 12px;
      width: 12px;
    }
    padding: 2vw 3.7vw;
    border-radius: 3vw;
    ${(props) => props.requestGroup && 'border-radius: 50%'}
    ${(props) => props.requestGroup && 'padding: 6px 8px'}
  }
`;

export const ButtonAdd = styled.button`
  padding: 8px 12px;
  background: #fafafa;
  border-radius: 50%;
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  :disabled {
    cursor: not-allowed;
  }
  &:hover {
    background-color: ${({ noHover }) =>
      noHover ? '#fafafa;' : 'rgba(140, 16, 254, 0.05);'};
    cursor: ${({ noHover }) => (noHover ? 'text;' : 'pointer;')};
  }
  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 610px) {
    padding: 10px 12px;
    margin: 5px 0;
  }
`;

export const FilterSearch = styled.input`
  width: 100%;
  border: 2px solid #ecedf0;
  border-radius: 14px;
  font-size: 16px;
  line-height: 19px;

  color: #222224;
  padding: 14px 20px;

  margin-top: 8px;
  margin-bottom: 4px;

  ::placeholder {
    color: #7f7f82;
  }
  @media (max-width: 1200px) {
    line-height: 1;
    margin-top: 10px;
    margin-bottom: 8px;
    padding: 10px 14px;
  }
  @media (max-width: 1024px) {
    padding: 8px 10px;
    font-size: 14px;
  }
  @media (max-width: 610px) {
    font-size: 2.5vw;
    margin-top: 2vw;
    margin-bottom: 2vw;
    padding: 1.5vw 3vw;
    border-radius: 2vw;
  }
`;

export const FilterItem = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  padding: 12px 10px;
  margin: 10px 0 5px;
  min-width: 190px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  justify-content: space-between;
  text-align: left;
  color: ${({ isActive }) => (isActive ? '#8C10FE' : '#222224')};
  ${({ isActive }) => isActive && 'background: rgba(140,16,254,0.05);'}

  &:hover {
    ${({ isActive }) => !isActive && 'background: rgba(20, 6, 14, 0.03);'}
    cursor: pointer;
  }
  @media (max-width: 1024px) {
    font-size: 14px;
    line-height: 1;
  }
  @media (max-width: 610px) {
    font-size: 2.7vw;
    padding: 0 3vw;
    min-width: 40vw;
    p {
      margin: 3vw 0;
    }
    svg {
      width: 5vw;
      height: 5vw;
      path {
        fill: #000;
      }
    }
  }
`;

export const EmptyList = styled.div`
  width: 64%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  z-index: 1;
  ${({ show }) => show && 'visibility:hidden'}
  span {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #222224;
    margin: 0;
    padding: 0;
  }
  p {
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: #7f7f82;
    margin: 0;
    padding: 0;
    margin-top: 4px;
  }
  svg {
    margin-bottom: ${(props) => (props.inbox ? '16px' : '8px')};
    width: 40px;
    height: 40px;
  }
  @media (max-width: 800px) {
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 66px;
    width: calc(100vw - 66px);
    transition: 0.4s;
    transform: translateX(${(props) => (props.active ? 0 : '100vw')});
    z-index: ${(props) => (props.active ? 10 : 0)};
  }
  @media (max-width: 610px) {
    left: 13vw;
    width: calc(100vw - 13vw);
    span {
      font-size: 5vw;
    }
    p {
      font-size: 4vw;
      padding: 0 2vw;
    }
  }
`;

export const HeaderList = styled.div`
  width: 100%;
  padding: 24px 20px 16px 20px;
  display: flex;
  justify-content: space-between;
  border-top: ${(props) =>
    props.border === 'show' ? '1px solid #FAFAFA' : 'none'};
  @media (max-width: 1200px) {
    padding: 0 20px;
  }
  @media (max-width: 1024px) {
    padding: 0 10px;
  }
  @media (max-width: 610px) {
    padding: 0 3vw;
  }
`;
export const TitleList = styled.span`
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #bdbdc1;
  @media (max-width: 1024px) {
    line-height: 1;
    font-size: 11px;
    padding-top: 10px;
  }
  @media (max-width: 800px) {
    font-size: 12px;
  }
  @media (max-width: 610px) {
    font-size: 3.2vw;
    padding-top: 3vw;
  }
`;
export const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 12px 0 26px 0px;

  @media (max-width: 1200px) {
    padding: 0;
    margin-top: 10px;
    ${(props) => !props.group && 'margin-bottom: 20px'};
  }
  @media (max-width: 1024px) {
    margin: 10px 0;
  }
  @media (max-width: 610px) {
    margin: 3vw 0;
    row-gap: 3vw;
  }
`;
export const ListItem = styled.div`
  width: 100%;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  /* align-items: center; */
  padding: 14px 12px;
  border-radius: 12px;
  color: ${(props) => (props.active ? '#8C10FE' : 'none')};
  column-gap: 10px;
  cursor: pointer;
  &:hover {
    ${(props) => !props.active && 'background: rgba(20, 6, 14, 0.03);'}
  }
  background-color: ${(props) =>
    props.active ? 'rgba(140, 16, 254, 0.05)' : 'none'};
  @media (max-width: 1200px) {
    padding: 10px 12px;
  }
  @media (max-width: 1024px) {
    border-radius: 8px;
    padding: 8px;
    column-gap: 8px;
  }
  @media (max-width: 800px) {
    padding: 12px;
    column-gap: 10px;
  }
  @media (max-width: 610px) {
    align-items: flex-start;
    padding: 3vw;
    column-gap: 3vw;
    border-radius: 2vw;
  }
`;
export const Avatar = styled.div`
  width: 46px;
  height: 46px;
  display: flex;
  align-items: top;
  margin-right: 15px;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  background-color: #8c10fe0d;
  svg,
  img,
  span {
    width: 100%;
    height: 100%;
  }
  background: ${(props) => props.isGroup && '#ECEDF0'};
  svg {
    width: ${(props) => props.isGroup && '50%'};
    height: ${(props) => props.isGroup && '50%'};
    ${({ isGroup }) => isGroup && 'margin: auto'}
  }

  @media (max-width: 1200px) {
    ${({ content }) => (content ? 'margin-top: 5px;' : '')}
    width: 38px;
    height: 38px;
  }
  @media (max-width: 1024px) {
    width: 30px;
    height: 30px;
  }
  @media (max-width: 800px) {
    width: 46px;
    height: 46px;
  }
  @media (max-width: 610px) {
    width: 10vw;
    height: 10vw;
  }
`;
export const ListItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  flex-wrap: wrap;

  span {
    ${(props) => !props.all && 'text-transform: capitalize'};
    font-weight: 600;
    font-size: 18px;
    color: ${(props) => (props.active ? '#8C10FE' : '#222224')};
    margin: ${({ content }) => (content ? '0' : '10px 0px')};
  }

  b {
    color: ${(props) => (props.active ? '#8C10FE' : ' #222224')};
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
  }
  @media (max-width: 1200px) {
    span {
      font-size: 16px;
      line-height: 1;
    }
  }
  @media (max-width: 1024px) {
    span {
      margin: 10px 0 5px;
      font-size: 14px;
    }
  }
  @media (max-width: 800px) {
    span {
      margin: 8px 0;
      font-size: 16px;
    }
  }
  @media (max-width: 610px) {
    width: 70%;
    margin: 0;
    span {
      font-size: 3.5vw;
      margin-left: 5px;
    }

    > div {
      column-gap: 2vw;
      width: 100%;
      position: relative;
    }
  }
`;

export const Row = styled.div`
  width: 100%;
  display: ${({ members }) => (members ? 'block' : 'flex')};
  flex-direction: row;
  align-items: center;
  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &:nth-child(n + 6) {
      display: ${({ isExpand }) => (isExpand ? 'none' : 'block')};
    }
  }
  @media (max-width: 1200px) {
    margin-bottom: 16px;
    &:last-of-type {
      margin: 0;
    }
  }
  @media (max-width: 610px) {
    margin-bottom: 3vw;
  }
`;

export const RowGroupElement = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: #4b4b4d;
  font-weight: normal;
  text-overflow: clip;
`;

export const RowElement = styled.p`
  font-size: 14px;
  line-height: ${({ height }) => (height ? '20px' : '24px')};
  color: ${({ time }) => (time ? '#BDBDC1' : '#4b4b4d')};
  max-height: 24px;
  ${({ name }) => !name && 'margin-left: 5px'};
  max-width: 200px;
`;

export const Point = styled.i`
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => (props.active ? '#8C10FE' : '#7F7F82')};
  margin: -4px 4px;
  @media (max-width: 1200px) {
    margin: 0 4px;
    line-height: 12px;
  }
  @media (max-width: 1024px) {
    line-height: 10px;
  }
  @media (max-width: 800px) {
    line-height: 14px;
    margin: 0 6px;
    font-weight: bold;
  }
  @media (max-width: 610px) {
    display: none;
  }
`;

export const InfoArea = styled.div`
  border: 2px solid #ecedf0;
  border-radius: 16px;
  text-align: center;
  padding: 16px;
  max-width: 335px;
  font-size: 18px;
  line-height: 30px;

  margin-bottom: 32px;
`;
